module.exports = __webpack_public_path__ + "img/mzc_credit.47e86b68.png";